import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

import CCADetails from "./CCADetails";
import Document from "./Document";
import ResinSystem from "./ResinSystem";

import { siteInfoSheetManager } from "../_shark_jaws/managers/siteInfoSheetManager";

class ConstructionSiteCard extends SmartModel {
	static STATUS_WAITING = 1;
	static STATUS_READY_TO_START = 5;
	static STATUS_CS_STARTED = 2;
	static STATUS_CS_CLOSED_OK = 3;
	static STATUS_CS_CLOSED_KO = 4;


	quotationCode = ""; // Join field
	quotationExtraData = {}; // Join field
	quotationGuid = "";
	quotationLots = []; // Join field

	constructor (data) {
		super();

		// this.additionalNotesCycles = "";
		this.accessories = {
			sguscirDirectLight: false,
			sgusciLength: "",
			sgusciColor: "",
			sgusciNeeded: false,
			jointsMastic: false,
			jointsMasticLength: "",
			jointsMasticColor: "",
			jointsOnSightFlexPU: false,
			jointsOnSightFlexPULength: "",
			jointsOnSightFlexPUColor: "",
			jointsOnSightFlex602: false,
			jointsOnSightFlex602Length: "",
			jointsOnSightFlex602Color: "",

			jointsStructuralThick125Area: "",
			jointsStructuralThickl50Area: "",
			jointsStructuralThick200Area: "",
			jointsNeededToPreventCracks: false,
			jointsNeededForPresentCracks: false,
			jointsStructuralNeroArea: "",
			jointsStructuralGrigioArea: "",
			jointsStructuralBeigeArea: "",
			jointsStructuralBiancoArea: "",
			jointsStructuralAvorioArea: "",
			jointsStructuraMarroneArea: "",
			lShapedProfileStraightThick125Length: "",
			lShapedProfileStraightThick150Length: "",
			lShapedProfileStraightThick200Length: "",
			lShapedProfileCurvedThick125Length: "",
			lShapedProfileCurvedThick150Length: "",
			lShapedProfileCurvedThick200Length: "",
			fenceNeeded: false,
			fenceLength: "",
			newJerseyNeeded: false,
			newJerseyLength: "",
		};
		
		this.additionalNotes = {
			siteFurtherInfo: "",
			siteSmallSurfaceMarkup: false,
			siteClientSolvencyRequested: false,
		};

		this.applicatorTeamId = "";
		this.attachments = [];
		this.attachmentsGuids = [];
		this.ccaDetails = {}; // Join field
		this.ccaDetailsGuid = "";
		this.clientGuid = "";

		this.constructionSiteInfo = {
			floorDirectLight: false,
			floorTemp: "",
			roomTemp: "",
			supportHumidity: "",
		};

		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.endDate = "0000-00-00 00:00:00";

		this.customer = null;
		this.designer = null;
		this.endUser = null;

		this.extraData = {
			activityStatusId: 0, //1:...
			activityStatus: "",
			constructionSiteWorksheetDocumentGuid: "",
			constructionSiteWorksheetSkipped: false,
			// visitGuid: "",
			customerNotifications: [],
			lotId: -1,
			lotName: "",
			quotationCCA: "",
			quotationGuid: "",
			relatedGuids: {
				clientGuid: "",
				constructionSiteGuid: "",
				quotationGuid: "",
				siteInfoSheetGuid: "",
				visitGuid: "",
			},
			salesOfficeNotificationsRequestedDate: "0000-00-00 00:00:00",
			siteInfoSheetGuid: "",
			startTimeSlot: "Mattina",
			systemsChanged: false,

			techSpecs: {
				aggregates01: false,
				aggregates01Type: "",
				aggregates01Area: 0,
				aggregates02: false,
				aggregates02Type: "",
				aggregates02Area: 0,
				aggregateChosenLater: false,
				aggregateChosenLaterArea: 0,

				aggregatesGreenPaving: false,
				aggregatesGreenPavingType: "",
				aggregatesGreenPavingArea: 0,

				aggregatePatterns: false,
				aggregatesMix: false,
				aggregateLuminescent: false,
				aggregateLuminescentArea: 0,

				cemColor: false,
				cemColorType: "",
				cemColorArea: 0,

				gummyFreetimRAL: false,
				gummyFreetimRALNotes: "",
				notes: "",
			},
		};

		this.guid = "";
		this.invoiceReceiver = null;
		this.lotReferenceGuid = "";

		this.materialSetupZone = {
			available: false,
			electricalPowerAvailable: false,
			electricalPowerType: "",
			isApart: false,
			isApartNotes: "",
			items: [],
			notes: "",
			hardenerTF05: false,
			smallPallet: false,
			tecOil: false,
			type: ""
		};
		
		this.constructionSiteFolderGuid = "";
		this.siteInfoSheetGuid = "";
		this.visitGuid = "";

		this.registry = {
			clientAddress: "",
			clientAddressAndCity: "",
			clientCity: "",
			clientCommoditySector: "",
			clientEMail: "",
			clientGuid: "",
			clientName: "",
			clientNationalLocationsCount: "",
			clientPersonInCharge: "",
			clientPersonInChargeRole: "",
			clientPersonInChargeMobile: "",
			clientProvince: "",
			clientRegion: "",
			clientZip: "",

			customerGuid: "",//Committente 
			customerName: "",//Committente 
			designerGuid: "",//Progettista
			designerName: "",//Progettista
			endUserGuid: "",//Utilizzatore
			endUserName: "",//Utilizzatore
			invoiceReceiverGuid: "",//[Contatto per fatturazione]
			invoiceReceiverName: "",//[Contatto per fatturazione]

			siteLocation: {
				address: "",
				buyers: "",
				city: "",
				constructionCompanies: "",
				designers: "",
				interventionAreas: "",
				logisticNotes: "",
				name: "",
				personInCharge: {
					name: "",
					eMail: "",
					phone: ""
				},
				possibleAggressionsAndInteractions: "",
				province: "",
				region: "",
				zip: "",
			},

			siteIPMPersonInCharge: "",
			sitePremiseDestinations: [],
			sitePremiseScope: "",

			// ipmPersonInCharge: "",
			sqMToBeRealized: 0,
			siteVisitDate: "0000-00-00 00:00:00",
			substrateType: "",
			// visitDate: "0000-00-00 00:00:00",
		};

		this.signage = {
			littleMenCount: 0,
			littleMenNeeded: false,
			stripesColor: "",
			stripesLength: 0,
			stripesNeeded: false,
			zebraStripesColor: "",
			zebraStripesLength: 0,
			zebraStripesNeeded: false,
		};

		this.startDate = "0000-00-00 00:00:00";
		this.status = 0;//[1: In attesa di conferma, 5: Pronto a partire, 2: Partenza confermata, 3: Chiuso ok, 4: Chiuso non conforme, 9: Eliminato]

		this.subfloorPreparation = {
			fillings: {
				thickness1Cm: false,
				thickness1CmArea: 0,
				thickness2Cm: false,
				thickness2CmArea: 0,
				thickness3Cm: false,
				thickness3CmArea: 0,
				additionalInfo: ""
			},
			mechanicals: {
				sanding: false,
				sandingArea: 0,
				sandblasting: false,
				sandblastingArea: 0,
				shotPeening: false,
				shotPeeningArea: 0,
				existingResinSuction: false,
				existingResinSuctionArea: 0,
				smoothing: false,
				smoothingArea: 0,
				bushhammering: false,
				bushhammeringArea: 0,
				bobcatMilling: false,
				bobcatMillingArea: 0,
				diamondGrinding: false,
				diamondGrindingArea: 0,
				manualGrinding: false,
				manualGrindingArea: 0,
			},
			notes: "",
			shavings: { // Dave: nelle SIS l'ho chiamata "baseCoats", "shavings" non ha proprio senso
				Aquareg1: false,
				Aquareg1Area: 0,
				Aquareg2: false,
				Aquareg2Area: 0,
				Aquareg2Plus: false,
				Aquareg2PlusArea: 0,
				Tecnireg1: false,
				Tecnireg1Area: 0,
				Tecnireg2: false,
				Tecnireg2Area: 0,
				Tecnireg2Plus: false,
				Tecnireg2PlusArea: 0,
			},
		};

		this.systems = {
			notes: "",
			systems: [],
		};

		this.type = "";

		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.userGuid = "";
		
		this.__agentName = "";
		this.__applicatorTeamName = "";
		this.__attachments = [];
		this.__creationNotesJoints = "";
		this.__creationNotesSlopeRecovery = "";
		this.__customerName = "";
		this.__designerName = "";
		this.__endDate = "0000-00-00 00:00:00";
		this.__endUserName = "";
		this.__followUpList = [];
		this.__hasExtraDates = false;
		this.__hasFollowUp = false;
		this.__hasNewFollowUp = false;
		this.__invoiceReceiverName = "";
		this.__render = true;
		this.__reportData = {};
		this.__startDate = "0000-00-00 00:00:00";
		this.__statusFurtherInformation = "";
		this.__statusLabel = "";
		this.__type_industrial = true;
		this.__visitDate = "0000-00-00 00:00:00";

		if (data) {
			//Dave.Warn: Questo import non mantiene i valori di default espressi sopra, verifica perché e risolvi.
			this.import(data);
		}
	}

	evaluateExtraDates () {
		if (this.quotationLots && this.quotationLots.length > 0) {
			//Dave: su "cose vecchie" sembra che ci siano i lot, ma non sono correttamente collegati alle CSC (cscGuid = "") e quindi non recupera le date multiple correttamente.
			// Certo, è tutto da sistemare con i "CCADetails", ma va risolto.
			const lotIndex = Utils.safp(this.quotationLots, "cscGuid", this.guid, "index");

			if (lotIndex !== null && lotIndex > -1) {
				const currLot = this.quotationLots[lotIndex];

				if (currLot.multipleDates && currLot.multipleDates.length > 0) {
					this.__extraDates = [];

					currLot.multipleDates.forEach(item => {
						//Dave: questa cosa è da spostare altrove
						const applicatorTeamList = Shark.get("applicatorTeamList");
						const cloned = Object.assign({}, item);

						if (applicatorTeamList && applicatorTeamList.length > 0) {
							const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", item.applicatorTeamId);
				
							if (currApplicatorTeam) {
								cloned.__applicatorTeamName = currApplicatorTeam.name;
							}
						}

						if (typeof item.constructionEndDateTime.isValid === "undefined") {
							item.constructionEndDateTime = moment(item.constructionEndDateTime);
							item.constructionStartDateTime = moment(item.constructionStartDateTime);
						}
						
						cloned.__timeSpanEndLabel = item.constructionEndDateTime.format(Shark.get("dateHumanFormat"));
						cloned.__timeSpanStartLabel = item.constructionStartDateTime.format(Shark.get("dateHumanFormat"));
				
						this.__extraDates.push(cloned);
					});

					this.__hasExtraDates = this.__extraDates.length > 1;
				}
			}
		}
		else {
			if (this.quotationExtraData && this.quotationExtraData.confirmData && this.quotationExtraData.confirmData.timeSpanAndApplicatorTeam.extraDates) {
				this.__extraDates = [];

				this.quotationExtraData.confirmData.timeSpanAndApplicatorTeam.extraDates.forEach(item => {
					//Dave: questa cosa è da spostare altrove
					const applicatorTeamList = Shark.get("applicatorTeamList");
					const cloned = Object.assign({}, item);

					if (applicatorTeamList && applicatorTeamList.length > 0) {
						const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", item.applicatorTeamId);
			
						if (currApplicatorTeam) {
							cloned.__applicatorTeamName = currApplicatorTeam.name;
						}
					}

					if (typeof item.constructionEndDateTime.isValid === "undefined") {
						item.constructionEndDateTime = moment(item.constructionEndDateTime);
						item.constructionStartDateTime = moment(item.constructionStartDateTime);
					}
					
					cloned.__timeSpanEndLabel = item.constructionEndDateTime.format(Shark.get("dateHumanFormat"));
					cloned.__timeSpanStartLabel = item.constructionStartDateTime.format(Shark.get("dateHumanFormat"));
			
					this.__extraDates.push(cloned);
				});

				this.__hasExtraDates = this.__extraDates.length > 1;
			}
		}
	}

	evaluateSiteLocationLabel () {
		if (this.registry.siteLocation.name !== "") {
			this.__siteLocationLabel = this.registry.siteLocation.name;
		}
		else {
			this.__siteLocationLabel = "Sede Legale";
		}

		if (this.registry.siteLocation.interventionAreas !== "") {
			this.__siteLocationLabel += " - " + this.registry.siteLocation.interventionAreas;
		}
	}

	export () {
		var exportData = this.__export();

		exportData.endDate = this.exportDateField("endDate");
		exportData.startDate = this.exportDateField("startDate");

		exportData.additionalNotes = JSON.stringify(this.additionalNotes);
		exportData.accessories = JSON.stringify(this.accessories);
		exportData.constructionSiteInfo = JSON.stringify(this.constructionSiteInfo);
		exportData.extraData = JSON.stringify(this.extraData);
		exportData.materialSetupZone = JSON.stringify(this.materialSetupZone);
		exportData.registry = JSON.stringify(this.registry);
		exportData.signage = JSON.stringify(this.signage);
		exportData.subfloorPreparation = JSON.stringify(this.subfloorPreparation);
		
		exportData.systems = JSON.stringify(this.systems.map(item => {
			const data = item.export();
			data.systems = data.systems.map(system => system.export());

			delete data.area;
			delete data.jobType;
			delete data.jobTypeSpec;
			delete data.scope;
			delete data.delete;
			delete data.thickness;
			delete data.systemNote;
			delete data.preparation;
			delete data.proposalGroup;
	
			return data;
		}));

		exportData.attachmentsGuids = this.exportArrayField("attachmentsGuids");
		exportData.attachments = JSON.stringify(this.attachments);
		console.log("ConstructionSiteCard.export", {exportData});
		return exportData;
	}

	import(data, options) {
		this.__import(data, options);

		const agentList = Shark.get("agentList");
		if (agentList) {
			const currAgent = Utils.safp(agentList, "guid", this.userGuid);
			if (currAgent) {
				this.__agentName = currAgent.__fullName;
			}
		}

		const applicatorTeamList = Shark.get("applicatorTeamList");
		if (applicatorTeamList && applicatorTeamList.length > 0) {
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.applicatorTeamId);

			if (currApplicatorTeam) {
				this.__applicatorTeamName = currApplicatorTeam.name;
			}
		}

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.isValid() ? this.createdAt.format("YYYY-MM-DD") : "";
			this.__createdAtLabel = this.createdAt.isValid() ? this.createdAt.format("DD/MM/YYYY") : "";
		}
		if (this.importDateField("endDate", data.endDate)) {
			this.__endDate = this.endDate.isValid() ? this.endDate.format("YYYY-MM-DD") : "";
			this.__endDateLabel = this.endDate.isValid() ? this.endDate.format("DD/MM/YYYY") : "";
		}
		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}

		this.importNumberField("newFollowUpCount", data.newFollowUpCount);

		if (this.importDateField("startDate", data.startDate)) {
			this.__startDate = this.startDate.isValid() ? this.startDate.format("YYYY-MM-DD") : "";
			this.__startDateLabel = this.startDate.isValid() ? this.startDate.format("DD/MM/YYYY") : "";
		}

		if (data.additionalNotes && data.additionalNotes !== "") {
			this.additionalNotes = Utils.parseJSON(data.additionalNotes, "object");
		}

		if (this.importDateField("registry.siteVisitDate", this.registry.siteVisitDate)) {
			this.__siteVisitDate = this.registry.siteVisitDate.isValid() ? this.registry.siteVisitDate.format(Shark.get("dtIsoDate")) : "";
			this.__siteVisitDateLabel = this.registry.siteVisitDate.isValid() ? this.registry.siteVisitDate.format(Shark.get("dateHumanFormat")) : "";
		}

		this.importNumberField("status", data.status);

		this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		this.__hasNewFollowUp = this.newFollowUpCount > 0;

		this.__reportData.agentGuid = this.userGuid;
		this.__reportData.agentName = this.registry.siteIPMPersonInCharge;
		this.__reportData.province = this.registry.clientProvince;
		this.__reportData.sector = this.registry.clientCommoditySector;

		if (this.status === 1) {
			this.__statusFurtherInformation = "";

			if (this.extraData.quotationCCA === "") {
				this.__statusFurtherInformation += "<br>Manca CCA";
			}
			if (this.extraData.constructionSiteWorksheetDocumentGuid === "") {
				this.__statusFurtherInformation += "<br>Manca Foglio Lavoro";
			}
			if (this.__statusFurtherInformation !== "") {
				this.__statusFurtherInformation = "<small>" + this.__statusFurtherInformation + "</small>";
			}
		}
		else {
			this.__statusFurtherInformation = "";
		}

		if (data.systems && data.systems !== "") {
			const systems =  Utils.parseJSON(data.systems, "object");
			this.systems = systems;
			
			this.systems = systems.map(item => Shark.getInstance("__smart__", {
				premiseDestination: item.premiseDestination,
				premiseNote: item.premiseNote,
				substrateType: item.substrateType,
				systems: item.systems.map(system => {
					const newSystem = new ResinSystem(system);

					// const newSystem = Shark.getInstance("__smart__", {
					// 	area: parseFloat(system.area),
					// 	jobType: system.jobType,
					// 	__jobTypeLabel: system.jobType === "new" ? "INTERVENTO SUL NUOVO" : "INTERVENTO DI RIPRISTINO/RIFACIMENTO",
					// 	jobTypeSpec: system.jobTypeSpec,
					// 	otherSystemNote: system.otherSystemNote || "",
					// 	scope: system.scope,
					// 	system: system.system,
					// 	systemNote: system.systemNote,
					// 	substrateType: system.substrateType,
					// 	preparation: system.preparation,
					// 	proposalGroup: isNaN(parseFloat(system.proposalGroup)) ? -1 : parseFloat(system.proposalGroup),
					// 	thickness: isNaN(parseFloat(system.thickness)) ? 0 : parseFloat(system.thickness),

					// 	ralColor: system.ralColor,
					// 	pasteColor: system.pasteColor,

					// 	__isOtherSystem: system.system === "ALTRO",
					// 	__isNewJob: system.jobType === "new",
					// 	__isRemakeJob: system.jobType === "remake",
					// });

					// newSystem.onDataChanged = function (data) {
					// 	switch (data.property) {
					// 		case "system":
					// 			//Dave: Questa cosaì è pericolosissima, dovrei darre un ID a tutti i Sistemi
					// 			const wasOtherSystem = this.__isOtherSystem;
					// 			this.__isOtherSystem = data.newValue === "ALTRO";
			
					// 			if (wasOtherSystem !== this.__isOtherSystem) {
					// 				//Dave: Anche il render da qui non mi piace
					// 				Shark.render();
					// 			}
					// 			break;
					// 		case "jobType":
					// 			this.__isNewJob = data.newValue === "new";
					// 			this.__isRemakeJob = data.newValue === "remake";
					// 			break;
					// 	}
					// 	console.log(data, this);
					// };

					return newSystem;
				}),
			}));

			siteInfoSheetManager.reindexSystem(this);

			this.__showNewJob = false;
			this.__showRemakeJob = false;

			this.__areasLabel = "";
			this.__systemsLabel = "";
			
			this.systems.forEach((item, index) => {
				if (item.systems) {
					item.systems.forEach((system) => {
						let proposalGroupLabel = "";
						
						if (system.proposalGroup > -1) {
							proposalGroupLabel = system.proposalGroup === 0 ? ` <span class="text-primary icon-thumbs-up"></span>` : ` <span class="text-info">A${system.proposalGroup}</span>`;
							// proposalGroupLabel = system.proposalGroup === 0 ? "Proposta consigliata" : "Proposta alternativa " + system.proposalGroup;
							// proposalGroupLabel = " <small>(" + proposalGroupLabel + ")</small>";
						}
						
						this.__areasLabel += `<strong>${system.area}</strong> m<sup>2</sup> (<strong>${system.thickness}</strong> mm)<br>` ;
						this.__systemsLabel += `${system.system}${proposalGroupLabel}<br>`;
						system.__printLabel = `${system.system} ${proposalGroupLabel}`;
						system.__displayIndex = index + 1;

					}, this);
				}
				else {
					this.__areasLabel += `<strong>${item.area}</strong> m<sup>2</sup> (<strong>${item.thickness}</strong> mm)<br>` ;
					this.__systemsLabel += `${item.system}<br>` ;
				}
			}, this);
		}

		if (typeof data.latestFollowUp === "string") {
			this.latestFollowUp = data.latestFollowUp;
			this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		}

		if (data.attachments && data.attachments !== "") {
			this.attachments = Utils.parseJSON(data.attachments, "array");

			//Dave,ToDo; Occhio alla schifezza
			if (this.attachments.length > 0 && typeof this.attachments[0] === "string") {
				this.attachments = this.attachments.map(item => {
					return {
						label: item.substr(item.lastIndexOf("/") + 1),
						thumbURL: ["jpg", "png"].indexOf(item.substr(item.lastIndexOf(".") + 1)) === -1 ? "/images/icons/" + item.substr(item.lastIndexOf(".") + 1) + ".png" : Shark.get("__cdnURL") + "/" + item,//.replace("ublic", "public"),
						type: item.substr(item.lastIndexOf(".") + 1),
						url: Shark.get("__cdnURL") + "/" + item,//.replace("ublic", "public")
					};
				});
				this.__firstPictureUrl = this.attachments[0];
			}
		}

		this.__sitePremiseScopePrivate = this.registry.sitePremiseScope === "private";
		this.__sitePremiseScopePublic = this.registry.sitePremiseScope === "public";

		this.__startTimeSlotLabel = this.extraData.startTimeSlot === "Mattina" ? "M" : "P";

		this.__typeLabel = this.type === "industrial" ? "Industriale" : (this.type === "outdoor" ? "Outdoor" : "N/D");
		this.__type_industrial = this.type === "industrial";
		this.__type_outdoor = this.type === "outdoor";

		this.evaluateSiteLocationLabel();
		this.evaluateExtraDates();
		this.parseAttachment();
		this.parseCCA(); // A tendere deve sparire in favore di parseCCADetails();
		this.parseCCADetails();
		this.parseLot();
		this.parseQuotationExtraData();
		this.parseRegistry();
		this.parseStatus();
	}

	isValid () {
		this.validate();

		return this.__isValid;
	}

	matchAttachmentsWithDocuments (documentList) {
		this.__attachments = this.__attachments.map(item => {
			const document = Utils.safp(documentList, "guid", item.guid);

			if (document) {
				document.__canBeDeleted = document.source === "constructionSiteCard";
			}

			return document || item;
		});
	}

	onDataChanged(data) {
		// console.log({data});

		switch (data.property) {
			case "__followUpList":
				this.__hasFollowUp = this.__followUpList.length > 0;
				break;
			case "clientGuid": {
				const client = Utils.safp(Shark.get("clientList"), "guid", this.clientGuid);
				if (client) {
					this.clientName = client.name;
				}
				break;
			}
			case "__startDate":
			case "__endDate":
				this[data.property.substr(2)] = moment(data.newValue);
				this[data.property + "Label"] = this[data.property.substr(2)]._isValid ? this[data.property.substr(2)].format("DD/MM/YYYY") : "";
				break;
			case "registry.clientGuid": {
				const currClient = Utils.safp(Shark.get("clientList"), "guid", data.newValue);

				if (currClient) {
					this.registry.clientAddressAndCity = `${currClient.address}, ${currClient.city} (${currClient.province})`;
					this.registry.clientEMail = currClient.email;
					this.registry.clientName = currClient.name;
					// Shark.render();
				}
				break;
			}
			case "registry.customerGuid": {
				this.set("clientGuid", data.newValue);
				this.set("registry.clientGuid", data.newValue);

				//Dave: Tutti questi giri vanno unificati con i set...
				const clientList = Shark.get("clientList");
				const customer = Utils.safp(clientList, "guid", this.registry.customerGuid);
				if (customer) {
					this.__customerName = customer.name;
					this.__customerSetted = true;
				}

				break;
			}
			case "registry.__visitDate":
				this.registry.visitDate = moment(data.newValue);
				break;
		}
		// console.log(this);
	}

	onExtraData_confirmData_timeSpanAndApplicatorTeam_extraDatesChanged () {
		this.evaluateExtraDates();
	}

	onExtraData_lotIdChanged () {
		this.parseLot();
	}

	parseAttachment () {
		this.__attachments = [];

		if (this.__attachments.length === 0 && this.attachmentsGuids.length > 0) {
			this.__attachments.push(...this.attachmentsGuids.map(guid => {
				return new Document({
					guid,
				});
			}));
		}

		if (this.attachments.length > 0) {
			this.__attachments.push(...this.attachments.filter(item => !this.attachmentsGuids.includes(item.guid), this).map(item => {
				item.fileURL = item.url;
				item.name = item.label;
				item.thumbnailURL = item.thumbURL;
				item.__canBeDeleted = document.source === "constructionSiteCard";

				// switch (item.type.toLowerCase()) {
				// 	case "doc":
				// 	case "docx":
				// 		item.thumbnailURL = "/" + docIcon;
				// 		break;
				// 	case "pdf":
				// 		item.thumbnailURL = "/" + pdfIcon;
				// 		break;
				// }

				return item;
			}));
		}
	}

	parseCCA () {
		if (this.extraData.quotationCCA && this.extraData.quotationCCA.trim() !== "") {
			this.__ccaLabel = this.extraData.quotationCCA;
		}
		else if (this.extraData.lotId !== undefined && this.extraData.lotId > -1 && this.quotationLots.length > 0 && this.quotationLots[this.extraData.lotId]) {
			this.__ccaLabel = this.quotationLots[this.extraData.lotId].cca;
		}
		else {
			this.__ccaLabel = "";
		}
	}

	parseCCADetails () {
		if (this.ccaDetailsGuid !== "") {
			this.ccaDetails = new CCADetails(this.ccaDetails);

			this.__hasExtraDates = false;

			if (this.ccaDetails.cca && this.ccaDetails.cca.trim() !== "") {
				this.__ccaLabel = this.ccaDetails.cca;
			}
			else {
				this.__ccaLabel = "";
			}

			if (this.ccaDetails.__timeSpanEnd && this.ccaDetails.__timeSpanEnd.trim() !== "") {
				this.__endDateLabel = this.ccaDetails.__timeSpanEndLabel;
			}

			if (this.ccaDetails.__timeSpanStart && this.ccaDetails.__timeSpanStart.trim() !== "") {
				this.__startDateLabel = this.ccaDetails.__timeSpanStartLabel;
			}
		}
	}

	parseLot () {
		if (this.extraData.lotId !== undefined && this.extraData.lotId > -1) {
			this.__lotIdLabel = this.extraData.lotId + 1;
			this.__lotId = this.extraData.lotId;
		}
		else {
			this.__lotIdLabel = "Lotto unico";
			this.__lotId = -1;
		}
	}

	parseQuotationExtraData () {
		let checkExtraData = false;

		if (this.quotationLots) {
			const lot = this.quotationLots.find(item => item.cscGuid === this.guid, this);

			if (lot) {
				this.__presumedAmount = lot.expetedAmount;
			}
			else {
				checkExtraData = true;
			}
		}
		else {
			checkExtraData = true;
			this.__presumedAmount = 0;
		}

		if (checkExtraData) {
			if (this.quotationExtraData && this.quotationExtraData.confirmData) {
				this.__presumedAmount = this.quotationExtraData.confirmData.presumedAmount;
			}
			else {
				this.__presumedAmount = 0;
			}
		}

		const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency" });
		this.__presumedAmountLabel = formatterCurrency.format(this.__presumedAmount);
	}

	parseRegistry () {
		//Dave.ToDo: visto che questa cosa del registry c'è in tanti posti, presumo dovrebbe diventare un oggetto
		//  Diciamo una roba legata al "Progetto" (anche se ancora non esiste), che abbia un solo punto di salvataggio e gli altri lo leggono e basta
		// const clientList = Shark.get("clientList");

		// if (clientList) {
		// 	if (this.registry.customerGuid !== "") {
		// 		const customer = Utils.safp(clientList, "guid", this.registry.customerGuid);
		// 		if (customer) {
		// 			this.__customerName = customer.name;
		// 			this.__customerSetted = true;
		// 		}
		// 	}
		// 	if (this.registry.designerGuid !== "") {
		// 		const designer = Utils.safp(clientList, "guid", this.registry.designerGuid);
		// 		if (designer) {
		// 			this.__designerName = designer.name;
		// 			this.__designerSetted = true;
		// 		}
		// 	}
		// 	if (this.registry.endUserGuid !== "") {
		// 		const endUser = Utils.safp(clientList, "guid", this.registry.endUserGuid);
		// 		if (endUser) {
		// 			this.__endUserName = endUser.name;
		// 			this.__endUserSetted = true;
		// 		}
		// 	}
		// 	if (this.registry.invoiceReceiverGuid !== "") {
		// 		const invoiceReceiver = Utils.safp(clientList, "guid", this.registry.invoiceReceiverGuid);
		// 		if (invoiceReceiver) {
		// 			this.__invoiceReceiverName = invoiceReceiver.name;
		// 			this.__invoiceReceiverSetted = true;
		// 		}
		// 	}
		// }

		const registry = this.registry;

		this.__receiverIsCustomer = registry.receiver === "customer";
		this.__receiverIsDesigner = registry.receiver === "designer";
		this.__receiverIsEndUser = registry.receiver === "endUser";

		// Dave: Questa roba del "_[role]Name" è tutta da uniformare e gestire.
		// this.__customerName = registry.customerName;
		// this.__designerName = registry.designerName;
		// this.__endUserName = registry.endUserName;

		if (this.__customerName === "") {
			this.__customerName = registry.customerName;
		}
		if (this.__designerName === "") {
			this.__designerName = registry.designerName;
		}
		if (this.__endUserName === "") {
			this.__endUserName = registry.endUserName;
		}
		if (this.__invoiceReceiverName === "") {
			this.__invoiceReceiverName = registry.invoiceReceiverName;
		}

		if (this.__customerName !== "") {
			this.__customerSetted = true;
		}
		if (this.__designerName !== "") {
			this.__designerSetted = true;
		}
		if (this.__endUserName !== "") {
			this.__endUserSetted = true;
		}
		if (this.__invoiceReceiverName !== "") {
			this.__invoiceReceiverSetted = true;
		}


		switch (registry.receiver) {
			case "customer":
				this.__receiverNameLabel = registry.customerName || this.__customerName || registry.clientName;
				this.__receiverTypeLabel = "Committente";
				break;
			case "designer":
				this.__receiverNameLabel = registry.designerName || this.__designerName || registry.clientName;
				this.__receiverTypeLabel = "Progettista";
				break;
			case "endUser":
				this.__receiverNameLabel = registry.endUserName || this.__endUserName || registry.clientName;
				this.__receiverTypeLabel = "Utilizzatore Finale";
				break;
		}

		//Se c'è un committente è lui che va mostrato, se no si passa al progettista, se no all'utente finale (in teoria impossibile)
		if (this.__customerName.trim() !== "") {
			this.__receiverNameLabel = this.__customerName;
			this.__receiverCSSClass = "customer";
			this.__receiverTypeLabel = "Committente";
		}
		else if (this.__designerName.trim() !== "") {
			this.__receiverNameLabel = this.__designerName;
			this.__receiverCSSClass = "designer";
			this.__receiverTypeLabel = "Progettista";
		}
		else if (this.__endUserName.trim() !== "") {
			this.__receiverNameLabel = this.__endUserName;
			this.__receiverCSSClass = "endUser";
			this.__receiverTypeLabel = "Utilizzatore finale";
		}
	}

	parseStatus () {
		switch (this.status) {
			case 1:
				this.__statusCSSClass = "cs-status-waiting";
				break;
			case 2:
				this.__statusCSSClass = "cs-status-started";
				break;
			case 5:
				this.__statusCSSClass = "cs-status-ready";
				break;
		}

		this.__statusLabel = Shark.get("constructionSiteCardStatusMap")[this.status];
		this.__status_waiting = this.status === 1;
		this.__reportData.status = this.status;
	}

	validate() {
		const errors = [];
		this.__errors = {};

		if (this.registry.customerGuid === "") {
			errors.push("Devi indicare il Committente");
			this.__errors.customer = true;
		}

		if (this.__startDate === "" || !this.startDate.isValid()) {
			errors.push("Bisonga inserire una data di partenza del cantiere, anche solo indicativa.");
			this.__errors.__startDate = true;
		}

		//Dave: mettiamo una regexp
		if (this.registry.siteLocation.personInCharge.eMail.trim() === "" || this.registry.siteLocation.personInCharge.eMail.indexOf(" ") > -1) {
			errors.push("Bisonga inserire un indirizzo eMail relativo al luogo di intervento, è necessario per le comunicazioni di IPM HUB verso il cliente.<br>Inserire <strong>un solo</strong> indirizzo eMail e verificare di averlo scritto correttamente.");
			this.__errors.siteLocation_eMail = true;
		}
		if (this.registry.siteLocation.name.trim() === "") {
			errors.push("È obbligatorio inserire una Sede per il luogo dell'intervento.");
			this.__errors.registry_siteLocation_name = true;
		}
		if (this.registry.siteLocation.interventionAreas.trim() === "") {
			errors.push("È obbligatorio inserire una Zona di Intervento per il luogo dell'intervento.");
			this.__errors.registry_siteLocation_interventionAreas = true;
		}
		if (this.registry.siteLocation.address.trim() === "") {
			errors.push("È obbligatorio inserire un indirizzo per il luogo dell'intervento.");
			this.__errors.registry_siteLocation_address = true;
		}
		if (this.registry.siteLocation.zip.trim() === "") {
			errors.push("È obbligatorio inserire un CAP per il luogo dell'intervento.");
			this.__errors.registry_siteLocation_zip = true;
		}
		if (this.registry.siteLocation.city.trim() === "") {
			errors.push("È obbligatorio inserire una Città per il luogo dell'intervento.");
			this.__errors.registry_siteLocation_city = true;
		}
		if (this.registry.siteLocation.province.trim() === "") {
			errors.push("È obbligatorio inserire una Provincia per il luogo dell'intervento.");
			this.__errors.registry_siteLocation_province = true;
		}

		if (isNaN(parseFloat(this.__presumedAmount)) || parseFloat(this.__presumedAmount) === 0) {
			errors.push("Bisogna indicare un importo presunto.");
			this.__errors.__presumedAmount = true;
		}
		// if (this.siteJobTypeAndPremiseDestination.trim() === "") {
		// 	errors.push("Il campo 'Natura del lavoro e destinazione locale' deve essere compilato");
		// }
		// if (this.siteSubstrateType.trim() === "") {
		// 	errors.push("Il tipo di sottofondo deve essere compilato");
		// }
		// if (this.preparations.length === 0) {
		// 	errors.push("Non hai indicato nessun tipo di preparazione");
		// }
		// if (this.actualWallSupportNatures.indexOf("Umido") > -1 && (this.actualWallSupportNaturesHumidityPercent.trim() === "" || parseInt(this.actualWallSupportNaturesHumidityPercent.trim()) === 0)) {
		// 	errors.push("Devi indicare la percentuale di umidità");
		// }
		// if (this.siteNeedsJoints && (this.siteJointsCost.trim() === "" || this.siteJointLength.trim() === "")) {
		// 	errors.push("Hai impostato la necessità di giunti ma non hai indicato i dettagli");
		// }
		// if (this.siteNeedsSgusci && (this.siteSgusciCost.trim() === "" || this.siteSgusciLength.trim() === "")) {
		// 	errors.push("Hai impostato la necessità di sgusci ma non hai indicato i dettagli");
		// }
		// if (this.siteNeedsSlopeRecovery && (this.siteSlopeRecoveryCost.trim() === "" || this.siteSlopeRecoverySM.trim() === "")) {
		// 	errors.push("Hai impostato la necessità di recupero di pendenze ma non hai indicato i dettagli");
		// }
	
		// if (this.attachments.length === 0) {
		// 	errors.push("Devi aggiungere almeno una foto o un allegato");
		// }


		if (this.systems.length === 0) {
			errors.push("Devi inserire almeno un'Area di Utilizzo");
			this.__errors.systems = true;
			this.__errorsCount++;
		}
		else {
			this.systems.forEach((interventionArea) => {
				const proposalGroupCounts = {
					0: 0,
					1: 0,
					2: 0,
					3: 0,
					4: 0,
					5: 0,
				};

				if (interventionArea.systems.length === 0) {
					errors.push("Devi inserire almeno un sistema in ogni Area di Utilizzo");
					this.__errorsCount++;
				}
				else {
					interventionArea.systems.forEach((system) => {
						if (system.proposalGroup === "" || system.proposalGroup === -1) {
							errors.push("Devi indicare la proposta per tutti i sitemi");
							this.__errors.proposalGroup = true;
							this.__errorsCount++;
						}
						else {
							proposalGroupCounts[system.proposalGroup]++;
						}
						if (system.system === "") {
							errors.push("Devi scegliere un sistema in ogni proposta inserita");
							this.__errors.systems = true;
							this.__errorsCount++;
						}
						if (system.system === "ALTRO" && system.otherSystemNote.trim() === "") {
							errors.push("Devi dare indicazioni dove hai scelto 'altro' come Sistema");
							this.__errors.systems = true;
							this.__errorsCount++;
						}
					});
				}
			});
		}


		this.__isValid = errors.length === 0;

		return errors;
	}
}

Shark.registerModel("ConstructionSiteCard", ConstructionSiteCard);

export default ConstructionSiteCard;